module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-17.e60d01c5.png";